<mat-checkbox [checked]="filterObject.active" (change)="handleToggle($event)">
  <mat-icon class="fa-2x warning-icon">report_problem</mat-icon>
</mat-checkbox>
